import { Select } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles/dropdown.css';
import { IFrequencyParams } from '../../../store/subscriptions';

export type TSelectOption = { value: string; label: string };
export type TSelectOptions = TSelectOption[];

export type TDropdownProps = {
  categoryName: string;
  itemId: number;
  isEnabled?: boolean;
  options: TSelectOptions;
  selectedValue?: string;
  onChange?(params: IFrequencyParams): void;
};

interface IDropdownState {
  selectedValue: string;
}

export class Dropdown extends React.PureComponent<TDropdownProps, IDropdownState> {
  public state: Readonly<IDropdownState> = {
    selectedValue: this.props.selectedValue || this.props.options[0].value,
  };

  public render() {
    const { options, isEnabled = true } = this.props;
    const { selectedValue } = this.state;

    return (
      <div className={styles['dropdown']}>
        <Select value={selectedValue} options={options} disabled={!isEnabled} onChange={this.handleChange} />
      </div>
    );
  }

  private handleChange = (value: string) => {
    const { categoryName, itemId, selectedValue: prevValue, onChange } = this.props;
    this.setState({ selectedValue: value });

    const params = {
      categoryName,
      frequency: value,
      itemId,
      // oxlint-disable-next-line typescript/no-non-null-assertion
      prevFrequency: prevValue!,
    };

    if (onChange) {
      onChange(params);
    }
  };
}
